export default __webpack_public_path__ + "static/media/rid_radio.d9a99fc6.svg";